// extracted by mini-css-extract-plugin
export default {"back":"models_back__arD87","model":"models_model__3NPk2","popupBtn":"models_popupBtn__r362f"};